import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UtilityService {
    private _numberToWord: { [key: number]: string } = {
        0: 'zero',
        1: 'one',
        2: 'two',
        3: 'three',
        4: 'four',
        5: 'five',
        6: 'six',
        7: 'seven',
        8: 'eight',
        9: 'nine',
        10: 'ten_or_more',
    };

    getNumberAsWord(number: number): string {
        return number < 10 ? this._numberToWord[number] : this._numberToWord[10];
    }

    clamp(num: number, min: number, max: number): number {
        return Math.min(Math.max(num, min), max);
    }

    async digestMessage(message: string) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

        return hashHex;
    }
}
